import gql from 'graphql-tag';

export const TemplateMediaSessionUploadQuery = gql`
	query TemplateMediaSessionUploadQuery(
		$spaceKey: String
		$templateIds: [String]!
		$collectionId: String
	) {
		templateMediaSession(
			spaceKey: $spaceKey
			templateIds: $templateIds
			collectionId: $collectionId
		) {
			collections {
				key
				value
			}
			configuration {
				fileStoreUrl
				clientId
			}
			uploadToken {
				value
				duration
			}
		}
	}
`;
